import type { FeatureNames } from "./feature-names";

/** Italian names of the staff features and settings categories. Same keys as features.fr.ts. */
export const featuresIt: FeatureNames = {
  features: {
    SEARCH_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Cercare account",
    VIEW_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Vedere un account",
    REVEAL_CONTACT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Mostrare un numero",
    EDIT_CUSTOMER_SETTINGS_STAFF_FEATURE_ENABLEMENT: "Modificare le impostazioni di un cliente",
    CLAIM_CASES_STAFF_FEATURE_ENABLEMENT: "Prendere in carico pratiche",
    REASSIGN_CASES_STAFF_FEATURE_ENABLEMENT: "Riassegnare pratiche",
    ACT_ON_BEHALF_STAFF_FEATURE_ENABLEMENT: "Agire per conto di un cliente",
    CORRECT_ACCOUNT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Correggere i dati di un account",
    REVIEW_VERIFICATIONS_STAFF_FEATURE_ENABLEMENT: "Esaminare le verifiche",
    VIEW_ID_IMAGES_STAFF_FEATURE_ENABLEMENT: "Vedere le immagini dei documenti d'identità",
    APPROVE_PROS_STAFF_FEATURE_ENABLEMENT: "Approvare i pro",
    VIEW_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Vedere i pagamenti",
    ISSUE_REFUNDS_STAFF_FEATURE_ENABLEMENT: "Rimborsare",
    ISSUE_CREDITS_STAFF_FEATURE_ENABLEMENT: "Concedere un credito",
    WAIVE_FEES_STAFF_FEATURE_ENABLEMENT: "Annullare commissioni",
    MARK_PAYMENTS_PAID_STAFF_FEATURE_ENABLEMENT: "Segnare un pagamento come pagato",
    MANAGE_PLAN_PRICES_STAFF_FEATURE_ENABLEMENT: "Impostare i prezzi dei piani",
    RUN_PROMOS_STAFF_FEATURE_ENABLEMENT: "Lanciare promozioni",
    OFFER_DISCOUNTS_STAFF_FEATURE_ENABLEMENT: "Concedere sconti",
    MANAGE_SUBSCRIPTIONS_STAFF_FEATURE_ENABLEMENT: "Prolungare o terminare un abbonamento",
    APPROVE_PAYMENT_REQUESTS_STAFF_FEATURE_ENABLEMENT: "Approvare oltre il limite",
    RECONCILE_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Riconciliare i pagamenti",
    EXPORT_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Esportare",
    HANDLE_REPORTS_STAFF_FEATURE_ENABLEMENT: "Gestire le segnalazioni",
    SET_REPORT_SEVERITY_STAFF_FEATURE_ENABLEMENT: "Stabilire la gravità di una segnalazione",
    SUSPEND_PENDING_INVESTIGATION_STAFF_FEATURE_ENABLEMENT: "Sospensione provvisoria",
    ISSUE_VERDICTS_STAFF_FEATURE_ENABLEMENT: "Emettere un verdetto",
    BAN_PERMANENTLY_STAFF_FEATURE_ENABLEMENT: "Bannare definitivamente",
    HANDLE_APPEALS_STAFF_FEATURE_ENABLEMENT: "Gestire i ricorsi",
    REFER_TO_POLICE_STAFF_FEATURE_ENABLEMENT: "Segnalare alla polizia",
    SHARE_DATA_WITH_POLICE_STAFF_FEATURE_ENABLEMENT: "Condividere dati con la polizia",
    PLACE_LEGAL_HOLDS_STAFF_FEATURE_ENABLEMENT: "Congelare le prove",
    MODERATE_REVIEWS_STAFF_FEATURE_ENABLEMENT: "Moderare le recensioni",
    SEND_SMS_STAFF_FEATURE_ENABLEMENT: "Inviare un SMS",
    SEND_BULK_SMS_STAFF_FEATURE_ENABLEMENT: "Inviare SMS di massa",
    EDIT_SMS_TEMPLATES_STAFF_FEATURE_ENABLEMENT: "Modificare i modelli di SMS",
    MANAGE_APP_FEATURES_STAFF_FEATURE_ENABLEMENT: "Gestire le funzionalità dell'app",
    EDIT_RULES_STAFF_FEATURE_ENABLEMENT: "Modificare le regole",
    EDIT_PRICING_STAFF_FEATURE_ENABLEMENT: "Modificare le tariffe",
    EDIT_CATEGORIES_STAFF_FEATURE_ENABLEMENT: "Modificare i mestieri",
    INVITE_STAFF_STAFF_FEATURE_ENABLEMENT: "Invitare nel team",
    DEACTIVATE_STAFF_STAFF_FEATURE_ENABLEMENT: "Disattivare un membro",
    END_STAFF_SESSIONS_STAFF_FEATURE_ENABLEMENT: "Chiudere le sessioni",
    MANAGE_TEAMS_STAFF_FEATURE_ENABLEMENT: "Gestire i team",
    MANAGE_ROLES_STAFF_FEATURE_ENABLEMENT: "Gestire i ruoli",
    MANAGE_ACTION_ENABLEMENTS_STAFF_FEATURE_ENABLEMENT: "Gestire le abilitazioni delle azioni",
    ASSIGN_ROLES_STAFF_FEATURE_ENABLEMENT: "Assegnare ruoli",
    MANAGE_LEADS_STAFF_FEATURE_ENABLEMENT: "Vendite e crescita",
    VIEW_MARKETPLACE_STAFF_FEATURE_ENABLEMENT: "Operazioni del mercato",
    MANAGE_HUMAN_RESOURCES_STAFF_FEATURE_ENABLEMENT: "Risorse umane",
    VIEW_AUDIT_LOG_STAFF_FEATURE_ENABLEMENT: "Consultare il registro di audit",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_FEATURE_ENABLEMENT: "Vedere i valori sensibili",
    VIEW_HEALTH_DASHBOARD_STAFF_FEATURE_ENABLEMENT: "Vedere la dashboard",
  },
  /** The permissions that sit on those features (ADR-0019), by settingId. */
  permissions: {
    ISSUE_REFUND_STAFF_PERMISSION: "Emettere un rimborso",
    SETTLE_REFUND_STAFF_PERMISSION: "Liquidare un rimborso",
    ISSUE_CREDIT_STAFF_PERMISSION: "Emettere un credito",
    WAIVE_FEE_STAFF_PERMISSION: "Annullare una commissione",
    REPLY_TO_CUSTOMER_STAFF_PERMISSION: "Rispondere a un cliente",
    CLOSE_CASE_STAFF_PERMISSION: "Chiudere una pratica",
  },
  /** Customer features (Fonctionnalités), by settingId. */
  customerFeatures: {
    SEARCH_PROS_USER_FEATURE_ENABLEMENT: "Cercare pro",
    NEARBY_PROS_USER_FEATURE_ENABLEMENT: "Pro nelle vicinanze",
    REQUEST_PRO_USER_FEATURE_ENABLEMENT: "Richiedere un pro",
    POST_OPEN_JOB_USER_FEATURE_ENABLEMENT: "Pubblicare una richiesta aperta",
    JOB_PHOTOS_USER_FEATURE_ENABLEMENT: "Foto in una richiesta",
    SELECT_QUOTE_USER_FEATURE_ENABLEMENT: "Scegliere un preventivo",
    LEAVE_REVIEWS_USER_FEATURE_ENABLEMENT: "Lasciare una recensione",
    REQUEST_CALLBACK_USER_FEATURE_ENABLEMENT: "Chiedere di essere richiamati",
    SAVE_FAVORITE_PROS_USER_FEATURE_ENABLEMENT: "Pro preferiti",
    REBOOK_PRO_USER_FEATURE_ENABLEMENT: "Riprenotare un pro",
    SHARE_PRO_PROFILE_USER_FEATURE_ENABLEMENT: "Condividere il profilo di un pro",
    SCHEDULE_JOB_USER_FEATURE_ENABLEMENT: "Programmare una richiesta",
    URGENT_JOB_USER_FEATURE_ENABLEMENT: "Richiesta urgente",
    BECOME_PRO_USER_FEATURE_ENABLEMENT: "Diventare pro",
    LEAD_PREFERENCES_USER_FEATURE_ENABLEMENT: "Preferenze sulle opportunità",
    EDIT_RATES_USER_FEATURE_ENABLEMENT: "Modificare le tariffe",
    BROWSE_OPEN_JOBS_USER_FEATURE_ENABLEMENT: "Sfogliare le richieste aperte",
    QUOTE_JOBS_USER_FEATURE_ENABLEMENT: "Preventivi sulle richieste",
    PRO_SUBSCRIPTIONS_USER_FEATURE_ENABLEMENT: "Abbonamenti pro",
    SUBMIT_VERIFICATION_USER_FEATURE_ENABLEMENT: "Inviare la verifica",
    PAUSE_LEADS_USER_FEATURE_ENABLEMENT: "Mettere in pausa le opportunità",
    PORTFOLIO_PHOTOS_USER_FEATURE_ENABLEMENT: "Foto dei lavori",
    QUICK_REPLIES_USER_FEATURE_ENABLEMENT: "Risposte rapide",
    ACTIVITY_PAGE_USER_FEATURE_ENABLEMENT: "Pagina attività",
    DECLARE_JOB_OUTCOME_USER_FEATURE_ENABLEMENT: "Dichiarare l'esito di una richiesta",
    LEAD_NOTIFICATIONS_USER_FEATURE_ENABLEMENT: "Opportunità via notifica",
    SMS_LEADS_USER_FEATURE_ENABLEMENT: "Opportunità via SMS",
    JOB_REMINDERS_USER_FEATURE_ENABLEMENT: "Promemoria delle richieste",
    SWITCH_MODE_USER_FEATURE_ENABLEMENT: "Passare da cliente a pro",
    MESSAGING_USER_FEATURE_ENABLEMENT: "Messaggistica",
    SEND_PHOTOS_USER_FEATURE_ENABLEMENT: "Inviare foto",
    SHARE_LOCATION_USER_FEATURE_ENABLEMENT: "Condividere la posizione",
    CHANGE_PHONE_USER_FEATURE_ENABLEMENT: "Cambiare numero",
    CHANGE_EMAIL_USER_FEATURE_ENABLEMENT: "Cambiare email",
    CONTACT_US_USER_FEATURE_ENABLEMENT: "Contattaci",
    CREATE_CLIENT_PROFILE_USER_FEATURE_ENABLEMENT: "Creare un profilo cliente",
    REPORT_USER_USER_FEATURE_ENABLEMENT: "Segnalare qualcuno",
    BLOCK_USER_USER_FEATURE_ENABLEMENT: "Bloccare qualcuno",
    APPEAL_DECISION_USER_FEATURE_ENABLEMENT: "Contestare una decisione",
    SECURITY_ACTIVITY_USER_FEATURE_ENABLEMENT: "Attività di sicurezza",
    REFER_FRIENDS_USER_FEATURE_ENABLEMENT: "Invitare amici",
  },
  /** Every action, so the audit log names what was done instead of its id (#185). */
  actions: {
    SIGN_UP_USER_ACTION: "Registrarsi",
    SIGN_IN_USER_ACTION: "Accedere",
    SIGN_OUT_USER_ACTION: "Uscire",
    UPDATE_PERSONAL_INFO_USER_ACTION: "Aggiornare i dati personali",
    CHANGE_PHONE_USER_ACTION: "Cambiare il numero di telefono",
    CHANGE_EMAIL_USER_ACTION: "Cambiare l'indirizzo email",
    CHANGE_PASSWORD_USER_ACTION: "Cambiare la password",
    SWITCH_MODE_USER_ACTION: "Passare da cliente a pro",
    CREATE_CLIENT_PROFILE_USER_ACTION: "Creare un profilo cliente",
    UPDATE_SETTING_USER_ACTION: "Modificare un'impostazione",
    VIEW_SECURITY_ACTIVITY_USER_ACTION: "Vedere l'attività di sicurezza",
    REFER_FRIEND_USER_ACTION: "Invitare un amico",
    DELETE_ACCOUNT_USER_ACTION: "Eliminare l'account",
    BECOME_PRO_USER_ACTION: "Diventare pro",
    SUBMIT_VERIFICATION_USER_ACTION: "Inviare un documento d'identità per la verifica",
    UPDATE_PRO_PROFILE_USER_ACTION: "Aggiornare il profilo pro",
    UPDATE_RATES_USER_ACTION: "Aggiornare le tariffe",
    ADD_PORTFOLIO_PHOTO_USER_ACTION: "Aggiungere una foto dei lavori",
    REMOVE_PORTFOLIO_PHOTO_USER_ACTION: "Rimuovere una foto dei lavori",
    UPDATE_LEAD_PREFERENCES_USER_ACTION: "Aggiornare le preferenze sulle opportunità",
    PAUSE_LEADS_USER_ACTION: "Mettere in pausa le opportunità",
    RESUME_LEADS_USER_ACTION: "Riprendere le opportunità",
    VIEW_OPEN_JOBS_USER_ACTION: "Vedere le richieste aperte",
    VIEW_ACTIVITY_USER_ACTION: "Vedere l'attività",
    REQUEST_PRO_USER_ACTION: "Richiedere un pro",
    POST_OPEN_JOB_USER_ACTION: "Pubblicare una richiesta aperta",
    REBOOK_PRO_USER_ACTION: "Riprenotare un pro",
    UPDATE_JOB_USER_ACTION: "Aggiornare una richiesta",
    ADD_JOB_PHOTOS_USER_ACTION: "Aggiungere foto a una richiesta",
    SCHEDULE_JOB_USER_ACTION: "Programmare una richiesta",
    MARK_JOB_URGENT_USER_ACTION: "Segnare una richiesta come urgente",
    SELECT_QUOTE_USER_ACTION: "Scegliere un preventivo",
    CANCEL_JOB_USER_ACTION: "Annullare una richiesta",
    SUBMIT_QUOTE_USER_ACTION: "Inviare un preventivo",
    UPDATE_QUOTE_USER_ACTION: "Aggiornare un preventivo",
    WITHDRAW_QUOTE_USER_ACTION: "Ritirare un preventivo",
    ACCEPT_JOB_USER_ACTION: "Accettare una richiesta",
    DECLINE_JOB_USER_ACTION: "Rifiutare una richiesta",
    DECLARE_JOB_OUTCOME_USER_ACTION: "Dichiarare l'esito di una richiesta",
    SEARCH_PROS_USER_ACTION: "Cercare pro",
    SEARCH_PROS_NEARBY_USER_ACTION: "Cercare pro nelle vicinanze",
    VIEW_PRO_PROFILE_USER_ACTION: "Vedere il profilo di un pro",
    SAVE_FAVORITE_PRO_USER_ACTION: "Salvare un pro preferito",
    REMOVE_FAVORITE_PRO_USER_ACTION: "Rimuovere un pro preferito",
    SHARE_PRO_PROFILE_USER_ACTION: "Condividere il profilo di un pro",
    OPEN_CONVERSATION_USER_ACTION: "Aprire una conversazione",
    SEND_MESSAGE_USER_ACTION: "Inviare un messaggio",
    SEND_PHOTO_USER_ACTION: "Inviare una foto",
    SHARE_LOCATION_USER_ACTION: "Condividere una posizione",
    READ_MESSAGES_USER_ACTION: "Leggere i messaggi",
    SAVE_QUICK_REPLY_USER_ACTION: "Salvare una risposta rapida",
    LEAVE_REVIEW_USER_ACTION: "Lasciare una recensione",
    SUBSCRIBE_TO_PLAN_USER_ACTION: "Abbonarsi a un piano",
    CANCEL_SUBSCRIPTION_USER_ACTION: "Annullare il rinnovo",
    RESUME_SUBSCRIPTION_USER_ACTION: "Riprendere il rinnovo",
    CHANGE_PLAN_USER_ACTION: "Cambiare piano",
    PAY_FEE_USER_ACTION: "Pagare una commissione",
    CONTACT_SUPPORT_USER_ACTION: "Contattare l'assistenza",
    REQUEST_CALLBACK_USER_ACTION: "Chiedere di essere richiamati",
    REPORT_USER_USER_ACTION: "Segnalare qualcuno",
    BLOCK_USER_USER_ACTION: "Bloccare qualcuno",
    UNBLOCK_USER_USER_ACTION: "Sbloccare qualcuno",
    APPEAL_DECISION_USER_ACTION: "Contestare una decisione",
    CREATE_EXPERIMENT_STAFF_ACTION: "Avviare un esperimento",
    MOVE_EXPERIMENT_STAFF_ACTION: "Ampliare o fermare un esperimento",
    ADD_LEAD_STAFF_ACTION: "Aggiungere un contatto",
    MOVE_LEAD_STAFF_ACTION: "Far avanzare un contatto",
    CREATE_CAMPAIGN_STAFF_ACTION: "Preparare una campagna",
    SEND_CAMPAIGN_STAFF_ACTION: "Inviare una campagna",
    OPEN_INCIDENT_STAFF_ACTION: "Aprire un incidente",
    UPDATE_INCIDENT_STAFF_ACTION: "Aggiornare un incidente",
    VIEW_MARKETPLACE_STAFF_ACTION: "Vedere come va il mercato",
    VIEW_MARKETPLACE_JOB_STAFF_ACTION: "Consultare una richiesta",
    SIGN_IN_STAFF_ACTION: "Accedere alla console",
    SIGN_OUT_STAFF_ACTION: "Uscire dalla console",
    SET_PASSWORD_STAFF_ACTION: "Impostare la password della console",
    UPDATE_STAFF_SETTING_STAFF_ACTION: "Modificare un'impostazione della console",
    SEARCH_ACCOUNTS_STAFF_ACTION: "Cercare account",
    VIEW_ACCOUNT_STAFF_ACTION: "Vedere un account",
    REVEAL_CONTACT_DETAILS_STAFF_ACTION: "Mostrare un numero di telefono",
    EDIT_CUSTOMER_SETTING_STAFF_ACTION: "Modificare l'impostazione di un cliente",
    CORRECT_ACCOUNT_DETAILS_STAFF_ACTION: "Correggere i dati di un account",
    CLAIM_CASE_STAFF_ACTION: "Prendere in carico una pratica",
    LOG_CALL_STAFF_ACTION: "Registrare una chiamata",
    REPLY_TO_CASE_STAFF_ACTION: "Rispondere a un cliente",
    ADD_CASE_NOTE_STAFF_ACTION: "Aggiungere una nota interna",
    CLOSE_CASE_STAFF_ACTION: "Chiudere una pratica",
    REASSIGN_CASE_STAFF_ACTION: "Riassegnare una pratica",
    LINK_CASE_CUSTOMER_STAFF_ACTION: "Collegare un cliente a una pratica",
    START_ON_BEHALF_SESSION_STAFF_ACTION: "Iniziare ad agire per conto di un cliente",
    END_ON_BEHALF_SESSION_STAFF_ACTION: "Smettere di agire per conto di un cliente",
    VIEW_VERIFICATION_STAFF_ACTION: "Vedere una verifica",
    APPROVE_VERIFICATION_STAFF_ACTION: "Approvare una verifica",
    REJECT_VERIFICATION_STAFF_ACTION: "Rifiutare una verifica",
    VIEW_ID_IMAGES_STAFF_ACTION: "Vedere le immagini dei documenti d'identità",
    APPROVE_PRO_STAFF_ACTION: "Approvare un pro",
    REJECT_PRO_STAFF_ACTION: "Rifiutare un pro",
    VIEW_PAYMENTS_STAFF_ACTION: "Vedere i pagamenti",
    ISSUE_REFUND_STAFF_ACTION: "Emettere un rimborso",
    ISSUE_CREDIT_STAFF_ACTION: "Emettere un credito",
    WAIVE_FEE_STAFF_ACTION: "Annullare una commissione",
    MARK_PAYMENT_PAID_STAFF_ACTION: "Segnare una commissione come pagata",
    APPROVE_PAYMENT_REQUEST_STAFF_ACTION: "Approvare una domanda",
    REJECT_PAYMENT_REQUEST_STAFF_ACTION: "Respingere una domanda",
    SETTLE_REFUND_STAFF_ACTION: "Liquidare un rimborso",
    SET_PLAN_PRICE_STAFF_ACTION: "Impostare il prezzo di un piano",
    CREATE_PROMO_STAFF_ACTION: "Creare una promozione",
    END_PROMO_STAFF_ACTION: "Terminare una promozione",
    CREATE_DISCOUNT_STAFF_ACTION: "Creare uno sconto",
    END_DISCOUNT_STAFF_ACTION: "Terminare uno sconto",
    EXTEND_SUBSCRIPTION_STAFF_ACTION: "Prolungare un abbonamento",
    END_SUBSCRIPTION_STAFF_ACTION: "Terminare un abbonamento",
    RECONCILE_PAYMENTS_STAFF_ACTION: "Riconciliare i pagamenti",
    EXPORT_PAYMENTS_STAFF_ACTION: "Esportare i pagamenti",
    OPEN_SAFETY_REPORT_STAFF_ACTION: "Aprire una segnalazione di sicurezza",
    ADD_REPORT_EVIDENCE_STAFF_ACTION: "Aggiungere prove a una segnalazione",
    SET_REPORT_SEVERITY_STAFF_ACTION: "Stabilire la gravità di una segnalazione",
    SUSPEND_PENDING_INVESTIGATION_STAFF_ACTION: "Sospendere un account in attesa dell'indagine",
    LIFT_SUSPENSION_STAFF_ACTION: "Revocare una sospensione",
    ISSUE_VERDICT_STAFF_ACTION: "Emettere un verdetto",
    BAN_PERMANENTLY_STAFF_ACTION: "Bannare un account definitivamente",
    DECIDE_APPEAL_STAFF_ACTION: "Decidere un ricorso",
    REFER_TO_POLICE_STAFF_ACTION: "Segnalare una pratica alla polizia",
    SHARE_DATA_WITH_POLICE_STAFF_ACTION: "Condividere dati con la polizia",
    PLACE_LEGAL_HOLD_STAFF_ACTION: "Applicare un congelamento delle prove",
    RELEASE_LEGAL_HOLD_STAFF_ACTION: "Revocare un congelamento delle prove",
    HIDE_REVIEW_STAFF_ACTION: "Nascondere una recensione",
    RESTORE_REVIEW_STAFF_ACTION: "Ripristinare una recensione",
    SEND_SMS_STAFF_ACTION: "Inviare un SMS",
    SEND_BULK_SMS_STAFF_ACTION: "Inviare un SMS a molte persone",
    EDIT_SMS_TEMPLATE_STAFF_ACTION: "Modificare un modello di SMS",
    SET_USER_FEATURE_ENABLEMENT_STAFF_ACTION: "Attivare o disattivare una funzionalità cliente",
    CREATE_RULE_VERSION_STAFF_ACTION: "Modificare una regola dell'azienda",
    EDIT_PRICING_STAFF_ACTION: "Modificare le fasce di commissioni",
    EDIT_CATEGORIES_STAFF_ACTION: "Modificare i mestieri",
    INVITE_STAFF_STAFF_ACTION: "Invitare un membro del team",
    DEACTIVATE_STAFF_STAFF_ACTION: "Disattivare un membro del team",
    REACTIVATE_STAFF_STAFF_ACTION: "Riattivare un membro del team",
    END_STAFF_SESSION_STAFF_ACTION: "Chiudere le sessioni di un membro del team",
    REQUEST_PERMISSION_STAFF_ACTION: "Chiedere un permesso",
    DECIDE_PERMISSION_REQUEST_STAFF_ACTION: "Rispondere a una richiesta di permesso",
    UPDATE_ACTION_ENABLEMENT_STAFF_ACTION: "Modificare l'abilitazione di un'azione",
    REQUEST_TIME_OFF_STAFF_ACTION: "Chiedere ferie",
    DECIDE_TIME_OFF_STAFF_ACTION: "Decidere una richiesta di ferie",
    SET_EMPLOYMENT_STAFF_ACTION: "Modificare un fascicolo di impiego",
    OPEN_JOB_STAFF_ACTION: "Aprire una posizione",
    EDIT_JOB_STAFF_ACTION: "Modificare una posizione",
    MOVE_CANDIDATE_STAFF_ACTION: "Far avanzare un candidato",
    OPEN_PAYROLL_STAFF_ACTION: "Aprire un mese di buste paga",
    EDIT_PAYROLL_LINE_STAFF_ACTION: "Sospendere o sbloccare una riga di busta paga",
    CLOSE_PAYROLL_STAFF_ACTION: "Chiudere un mese di buste paga",
    OPEN_REVIEW_CYCLE_STAFF_ACTION: "Aprire un ciclo di valutazione",
    WRITE_REVIEW_STAFF_ACTION: "Scrivere una valutazione",
    EDIT_COURSE_STAFF_ACTION: "Aggiungere o modificare un corso",
    ENROL_IN_COURSE_STAFF_ACTION: "Iscriversi a un corso",
    CREATE_TEAM_STAFF_ACTION: "Creare un team",
    EDIT_TEAM_STAFF_ACTION: "Modificare un team",
    SET_TEAM_MEMBERSHIP_STAFF_ACTION: "Definire chi fa parte del team",
    CREATE_ROLE_STAFF_ACTION: "Creare un ruolo",
    EDIT_ROLE_STAFF_ACTION: "Modificare un ruolo",
    SET_STAFF_PERMISSION_STAFF_ACTION: "Concedere o revocare un permesso",
    SET_STAFF_FEATURE_ENABLEMENT_STAFF_ACTION: "Concedere o revocare una funzionalità",
    ASSIGN_ROLE_STAFF_ACTION: "Assegnare un ruolo",
    REMOVE_ROLE_STAFF_ACTION: "Rimuovere un ruolo",
    VIEW_AUDIT_LOG_STAFF_ACTION: "Consultare il registro di audit",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_ACTION: "Vedere i valori sensibili dell'audit",
    VIEW_HEALTH_DASHBOARD_STAFF_ACTION: "Vedere la dashboard di salute",
    EXPIRE_JOB_SYSTEM_ACTION: "Far scadere una richiesta senza risposta",
    EXPIRE_QUOTE_SYSTEM_ACTION: "Far scadere un preventivo",
    CLOSE_OTHER_QUOTES_SYSTEM_ACTION: "Chiudere gli altri preventivi",
    OPEN_CONVERSATION_ON_QUOTE_SYSTEM_ACTION: "Aprire una conversazione su un preventivo",
    NOTIFY_USER_SYSTEM_ACTION: "Inviare una notifica",
    NOTIFY_NEW_LEAD_SYSTEM_ACTION: "Avvisare un pro di una nuova opportunità",
    SEND_LEAD_SMS_SYSTEM_ACTION: "Inviare un'opportunità via SMS",
    NOTIFY_JOB_REMINDER_SYSTEM_ACTION: "Inviare un promemoria di richiesta",
    CONFIRM_FEE_PAYMENT_SYSTEM_ACTION: "Confermare il pagamento di una commissione",
    FAIL_FEE_PAYMENT_SYSTEM_ACTION: "Registrare il pagamento fallito di una commissione",
    ACTIVATE_SUBSCRIPTION_SYSTEM_ACTION: "Attivare un abbonamento",
    SUSPEND_SUBSCRIPTION_SYSTEM_ACTION: "Sospendere un abbonamento",
    RENEW_SUBSCRIPTION_SYSTEM_ACTION: "Rinnovare un abbonamento",
    EXPIRE_SUBSCRIPTION_SYSTEM_ACTION: "Terminare un abbonamento scaduto",
    REMIND_SUBSCRIPTION_EXPIRY_SYSTEM_ACTION: "Ricordare a un pro che il suo piano sta per finire",
    EXPIRE_SETTING_VALUE_SYSTEM_ACTION: "Far scadere il valore di un'impostazione",
    DELETE_ID_IMAGES_SYSTEM_ACTION: "Eliminare le immagini dei documenti d'identità",
    FLAG_BANNED_DOCUMENT_SYSTEM_ACTION: "Segnalare un documento vietato",
    SUSPEND_ON_CRITICAL_REPORT_SYSTEM_ACTION: "Sospendere dopo una segnalazione critica",
  },
  /** The settings a person chooses for themselves, by settingId. */
  settings: {
    THEME_USER_SETTING: "Tema",
    COLOR_VIBE_USER_SETTING: "Colore",
    LANGUAGE_USER_SETTING: "Lingua",
    LOW_DATA_MODE_USER_SETTING: "Modalità dati ridotti",
    NEW_LEAD_NOTIFICATION_USER_SETTING: "Avvisarmi di nuove opportunità",
    QUOTE_RECEIVED_NOTIFICATION_USER_SETTING: "Avvisarmi quando arriva un preventivo",
    NEW_LEAD_SMS_USER_SETTING: "Inviare le nuove opportunità via SMS",
    QUOTE_RECEIVED_SMS_USER_SETTING: "Inviare un preventivo via SMS",
    LEAD_TRADES_USER_SETTING: "Mestieri per cui voglio opportunità",
    LEAD_SERVICE_AREA_USER_SETTING: "Dove lavoro",
    LEAD_RADIUS_USER_SETTING: "Fin dove mi sposto",
    LEAD_DAYS_USER_SETTING: "Giorni in cui accetto lavoro",
    URGENT_JOBS_USER_SETTING: "Richieste urgenti",
    CONSOLE_THEME_STAFF_SETTING: "Tema della console",
    CONSOLE_LANGUAGE_STAFF_SETTING: "Lingua della console",
  },
  /** The grid's section titles. */
  categories: {
    appearance: "Aspetto",
    notifications: "Notifiche",
    leads: "Opportunità",
    discovery: "Ricerca",
    jobs: "Richieste",
    profile: "Profilo",
    accounts: "Account",
    support: "Pratiche",
    onBehalf: "Per conto di un cliente",
    onboarding: "Verifica",
    payments: "Pagamenti",
    safety: "Fiducia e sicurezza",
    messaging: "Messaggi",
    configuration: "Configurazione",
    staff: "Team e accessi",
    audit: "Audit",
  },
};
